import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { ILifeEvent, LifeEvent } from '../LifeEvent.ts';
import { LifeEventsApi } from '../../../apis/LifeEventsApi/LifeEventsApi.ts';

export function usePostLifeEventMutations() {
    const queryClient = useQueryClient();

    return useMutation<ILifeEvent, AppMedError, ILifeEvent>({
        mutationKey: [QueryKeys.lifeEvents],
        mutationFn: async (variables: ILifeEvent) => {
            await LifeEventsApi.postLifeEvents(variables);
            return variables;
        },
        onSuccess: async (data: ILifeEvent) => {
            queryClient.setQueryData<LifeEvent[]>([QueryKeys.lifeEvents], (prev) => {
                prev?.push(data);
                return prev;
            });
            queryClient.setQueryData<LifeEvent>([QueryKeys.lifeEvent], () => {
                return data;
            });
        },
    });
}
